module.exports = __webpack_public_path__ + "img/a1.8617388.png";